import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import { logger, crashReporter } from './middleware/general-middleware';
import mediaGalleryReducers from './reducers/media-gallery-reducers';
import ErrorBoundry from './components/ErrorBoundry';
import MediaGalleryContainer from './components/media-gallery/MediaGalleryContainer';
import * as WidenUtils from './modules/widen-utils';
import * as FilterActions from './actions/filter-actions';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; /* eslint-disable-line no-underscore-dangle */

if (document.getElementById('media-gallery-root')) {
  WidenUtils.init(() => {
    const mediaGalleryStore = createStore(
      mediaGalleryReducers, {
        initialState: {
          mediaItems: window.MediaGalleryData.mediaItems,
          modal: {
            active: false,
            item: window.MediaGalleryData.mediaItems[0],
          },
        },
        filters: window.MediaGalleryData.filters,
        mediaItems: window.MediaGalleryData.mediaItems,
        selectedFilters: {
          imagesVideosFilter: [],
          productLineFilter: [],
          colorRangeFilter: [],
          designStyleFilter: [],
          roomTypeFilter: [],
        },
        filterToggle: false,
        modal: {
          active: false,
          item: window.MediaGalleryData.mediaItems[0],
        },
        assetLoadComplete: false,
      },
      composeEnhancers(applyMiddleware(logger, crashReporter)),
    );

    WidenUtils.setMediaLoadCallback(() => {
      mediaGalleryStore.dispatch(FilterActions.addMediaItems());
    });

    WidenUtils.setMediaLoadCompleteCallback(() => {
      mediaGalleryStore.dispatch(FilterActions.assetLoadComplete(true));
    });

    ReactDom.render(
      React.createElement(ErrorBoundry, null, React.createElement(Provider, {
        store: mediaGalleryStore,
      }, React.createElement(MediaGalleryContainer))),
      document.getElementById('media-gallery-root'),
    );
  });
}
